module.exports = __webpack_public_path__ + "img/dr_3.5e185b5b.png";